import TextInput from "Components/molecule/inputs/text-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import RoleFields from "./types"


const NAME_KEY = 'name'


const RoleForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting
}: FormProps<RoleFields>) => {

    return <div className="generate-documents-form">
        <TextInput
            touched={!!touched.name}
            name={NAME_KEY}
            key={NAME_KEY}
            label={"Role Name*"}
            placeholder={"Role Name"}
            value={values.name}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.name && !!errors.name}
            message={touched.name ? errors.name : undefined}
        />

        <PrimaryButton
            type='submit'
            onClick={() => handleSubmit()}
            disabled={isSubmitting || !isValid}
            style={{ width: '100%', height: '30px' }}>
            {isSubmitting ? "Submitting...." : "Submit"}
        </PrimaryButton>
    </div>
}

export default RoleForm